<template>
  <div class="fe-relative fe-h-full" ref="scrollContainer" :class="className">
    <slot></slot>
    <!-- <div v-if="isLoadingData && isInfiniteScroll">Loading more items...</div> -->
    <div ref="loadMoreTrigger" class="fe-h-[1px]"></div>
    <div v-if="!hidePrevNextCta" class="fe-mt-base fe-flex fe-gap-s">
      <JdsButton
        variant="secondary"
        @click="prevPage"
        :disabled="currentPage === 0"
      >
        <template #icon>
          <JdsIcon name="ChevronLeftIcon" size="m" color="fe-text-primary-60" />
        </template>
        Previous
      </JdsButton>
      <JdsButton variant="secondary" @click="nextPage" :disabled="!hasNext">
        <template #iconRight>
          <JdsIcon
            name="ChevronRightIcon"
            size="m"
            color="fe-text-primary-60"
          />
        </template>
        Next
      </JdsButton>
    </div>
  </div>
</template>

<script>
  import JdsButton from "@/components/DesignSystem/JdsButton/JdsButton.vue"
  import JdsIcon from "@/components/DesignSystem/JdsIcon/JdsIcon.vue"
  import { FYND_DEFAULT_HEADER_CLASSNAME } from "@/constants/constants"

  export default {
    name: "InfiniteScroll",
    components: {
      JdsButton,
      JdsIcon,
    },
    props: {
      isLoadingData: {
        type: Boolean,
        default: false,
      },
      className: {
        type: [Array, Object, String],
        default: "",
      },
      isInfiniteScroll: {
        type: Boolean,
        default: false,
      },
      currentPage: {
        type: Number,
        default: 0,
      },
      hasNext: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      hidePrevNextCta() {
        if (this.currentPage === 0 && !this.hasNext) {
          return true
        }

        return this.isInfiniteScroll
      },
    },
    mounted() {
      if (this.isInfiniteScroll) {
        this.observer = new IntersectionObserver(this.handleIntersect)
        this.observer.observe(this.$refs.loadMoreTrigger)
      }
    },
    beforeDestroy() {
      if (this.observer) {
        this.observer.disconnect()
      }
    },
    methods: {
      handleIntersect(entries) {
        if (entries[0].isIntersecting && !this.isLoadingData && this.hasNext) {
          this.$emit("load-more", this.currentPage + 1)
        }
      },
      nextPage() {
        if (this.hasNext) {
          this.$emit("change-page", this.currentPage + 1)
          this.scrollToContainerTop()
        }
      },
      prevPage() {
        if (this.currentPage > 0) {
          this.$emit("change-page", this.currentPage - 1)
          this.scrollToContainerTop()
        }
      },
      scrollToContainerTop() {
        // Get the bounding rectangle of the target element
        const elementRect = this.$refs.scrollContainer.getBoundingClientRect()

        // Get the Fixed/Sticky positioned Header offset height
        const headerElementHeight =
          document.querySelector(`.${FYND_DEFAULT_HEADER_CLASSNAME}`)
            ?.offsetHeight || 0

        const elementScrollPosition =
          window.scrollY + elementRect.top - headerElementHeight - 32 // 32 is Container's Title height (Product Reviews)

        // Scroll to the calculated element position
        window.scrollTo({
          top: elementScrollPosition,
          behavior: "smooth",
        })
      },
    },
  }
</script>
